import React from 'react';
import { change } from 'redux-form';
import {FormDataConsumer, SelectInput, REDUX_FORM_NAME, required} from 'react-admin';
import {addField} from 'ra-core';

const NestedSelectInput = props => {
    // eslint-disable-next-line react/prop-types
    const {
        source,
        fstSource,
        sndSource,
        fstLabel,
        sndLabel,
        fstChoices,
        getSndChoices,
        validate,
        thrdSource,
        thrdLabel,
        getThrdChoices,
        draft
    } = props;

    // Draft mode: the sector/subsector/tipo selects are optional (a draft may be
    // saved incomplete). Otherwise they are required. The `draft` prop is not
    // reliably forwarded through addField, so also detect the draft route from
    // the URL (drafts always live under /draft-projects/...).
    const isDraft = draft || (typeof window !== 'undefined' && window.location.hash.indexOf('/draft-projects') > -1);
    const reqOrNone = message => (isDraft ? undefined : [required(message)]);

    const getSndChoicesFromFirstValueId = valueID => {
        // eslint-disable-next-line react/prop-types
        const fstChoice = fstChoices.find(c => c.id === valueID);
        return fstChoice ? getSndChoices(fstChoice) : [];
    };

    const getThrdChoicesFromSecondValueId = (firsValueID, secondValueID) => {
        const sndChoices = getSndChoicesFromFirstValueId(firsValueID);
        const sndChoice = sndChoices.find(c => c.id === secondValueID);
        console.log({
            firsValueID,
            secondValueID,
            sndChoices,
            sndChoice,
        });
        return sndChoice ? getThrdChoices(sndChoice) : [];
    };

    // const displayNestedInput = formData =>
    //   formData[source] &&
    //   formData[fstSource] &&
    //   getSndChoicesFromFirstValueId(formData[fstSource]).length > 0;

    const nestedValidation = formData => {

        if (!formData[fstSource]) {
            // eslint-disable-next-line react/prop-types
            props.input.onChange('');
            return;
        }
        else if (
            getSndChoicesFromFirstValueId(formData[fstSource]).findIndex(
                c => c.id === formData[sndSource]
            ) < 0
        ) {
            // eslint-disable-next-line react/prop-types
            props.input.onChange({[fstSource]: formData[fstSource]});
            return;
        }
        else if (
            thrdSource &&
            getThrdChoicesFromSecondValueId(
                formData[fstSource],
                formData[sndSource]
            ).findIndex(c => c.id === formData[thrdSource]) < 0
        ) {
            // eslint-disable-next-line react/prop-types
            props.input.onChange({
                [fstSource]: formData[fstSource],
                [sndSource]: formData[sndSource]
            });
        }
    };

    function controlNestedInput(formData) {
        nestedValidation(formData);
        return true;
    }
    return (
        <>
            <FormDataConsumer>
                {({formData, dispatch, ...rest}) => {
                    console.log({formData});
                    return formData && (
                        <>
                            <SelectInput
                                source={`${fstSource}`}
                                choices={fstChoices}
                                label={fstLabel}
                                className="colInput"
                                validate={reqOrNone('Seleccione el sector')}
                                onChange={() => {
                                    if (sndSource) {
                                        dispatch(change(REDUX_FORM_NAME, sndSource, null));
                                    }
                                } }
                            />

                            <SelectInput
                                source={`${sndSource}`}
                                choices={
                                    formData[fstSource]
                                        ? getSndChoicesFromFirstValueId(formData[fstSource])
                                        : []
                                }
                                label={sndLabel}
                                className="colInput"
                                validate={reqOrNone('Seleccione el subsector')}
                                {...rest}
                                onChange={() => {
                                    if (thrdSource) {
                                        dispatch(change(REDUX_FORM_NAME, thrdSource, null));
                                    }
                                }}
                            />

                            {(thrdSource &&
                            <SelectInput
                                source={`${thrdSource}`}
                                choices={formData[fstSource] && formData[sndSource] ? getThrdChoicesFromSecondValueId(formData[fstSource], formData[sndSource]) : []}
                                label={thrdLabel}
                                className="colInput"
                                validate={reqOrNone('Seleccione el tipo de proyecto')}
                                {...rest}
                            />)}
                        </>
                    )}
                }
            </FormDataConsumer>
        </>
    );
};

export default addField(NestedSelectInput);
